import { Link } from 'react-router-dom';

export function FaultBadge({ count }: { count: number }) {
  if (count === 0) return null;
  return (
    <Link
      to="/faults"
      className="tag heat"
      aria-label={`${count} active fault${count === 1 ? '' : 's'}`}
      style={{ textDecoration: 'none' }}
    >
      ⚠ {count}
    </Link>
  );
}
